export const SET_IS_PRICEPOINT_SET_FROM_COOKIE = 'SET_IS_PRICEPOINT_SET_FROM_COOKIE';
export const RESET_IS_PRICEPOINT_SET_FROM_COOKIE = 'RESET_IS_PRICEPOINT_SET_FROM_COOKIE';

export type SetIsPricePointSetFromCookieAction = {
	type: typeof SET_IS_PRICEPOINT_SET_FROM_COOKIE;
	payload: boolean;
};

export type ResetIsPricePointSetFromCookieAction = {
	type: typeof RESET_IS_PRICEPOINT_SET_FROM_COOKIE;
};

export type IsPricePointSetFromCookieActionTypes =
	| SetIsPricePointSetFromCookieAction
	| ResetIsPricePointSetFromCookieAction;
